import React, { Component } from 'react';

import classes from './BookingEngineSelect.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelectOption from '../../UI/SelectMenu/SelectOption/SelectOption';

class BookingEngineSelect extends Component {


    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
      }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) => {
        if (this.node.contains(e.target)) return;
        this.props.closeFlightClassMenu();
    }

    render() {
        const colorDark = "var(--color-grey-dark-1)";
        console.log(this.props.originCountry !== "IN" && this.props.destinationCountry !== "IN");
        return (
            <div className={`u-relative u-height72 u-width100Percent u-flex align-items-end`}>
                <div className={`u-relative u-width100Percent`}>
                    <span className={classes.SelectMenuLabel}>Choose Class</span>
                    <div className={`${classes.SelectMenu} u-textColorDark u-fontSize16 u-block u-width100Percent u-flex justify-content-between u-cursorPointer`} onClick={this.props.openFlightClassMenu}>
                        <p>{this.props.flightClassText} Class</p>
                        <span><FontAwesomeIcon icon="angle-down" color={`${colorDark}`} size="1x" /></span>
                    </div>
                    <div ref={node => this.node = node}>
                    {
                        this.props.isFlightClassMenuOpen ? 
                        <ul className={`${classes.Select} u-boxShadowDropdown u-backgroundColorWhite u-borderRadius4 u-absolute u-overflowScroll u-width100Percent u-top15 u-left0`}>
                            <SelectOption onClick={() => this.props.selectFlightClass('Economy', 'Economy')}>Economy</SelectOption>
                            <SelectOption onClick={() => this.props.selectFlightClass('Business', 'Business')}>Business</SelectOption>
                            <SelectOption onClick={() => this.props.selectFlightClass('Premium Economy', 'Special')}>Premium Economy</SelectOption>
                            {this.props.originCountry !== "IN" || this.props.destinationCountry !== "IN" ? <SelectOption onClick={() => this.props.selectFlightClass('First', 'First')}>First Class</SelectOption> : null}
                        </ul> : null
                    }
                    </div>
                </div>
            </div>
        );
    }
}

export default BookingEngineSelect;


// WEBPACK FOOTER //
// ./src/components/BookingEngine/BookingEngineSelect/BookingEngineSelect.js